import { Extent, createEmpty, extend } from 'ol/extent';
import Geometry from 'ol/geom/Geometry';
import Feature from 'ol/Feature';

export class MapUtils {

    public static getExtentFromFeatures(features: any[]): Extent {
        const fExtent: Extent = createEmpty();
        let fGeometry: Geometry = null;
        features.forEach((feature: Feature) => {
            fGeometry = feature.getGeometry();
            if (fGeometry) {
                extend(fExtent, fGeometry.getExtent());
            }
        });
        return fExtent;
    }
}



// WEBPACK FOOTER //
// ./libs/map/utils/map.utils.ts